export const enumPermisosCorresponsalTransfiya = Object.freeze({
  TRANSFIYA_DEPOSITO: 30001,
  TRANSFIYA_COBRO: 30002,
  TRANSFIYA_RETIRO: 30003,
});

export const enumPermisosCorresponsalMovii = Object.freeze({
  MOVII_RETIROS: 49,
  MOVII_DEPOSITOS: 30000,
});
